import { FC } from 'react';
import { Trans, useTranslation } from '@frontend/i18n';
import { FormRow, Heading, Text, TextField } from '@frontend/design-system';
import { CreateSoftphonePropTypes, inputFieldStyles } from '..';

export const SecondStep: FC<React.PropsWithChildren<CreateSoftphonePropTypes>> = ({
  getFieldProps,
  values,
}: CreateSoftphonePropTypes) => {
  const { t } = useTranslation('phone', { keyPrefix: 'create-new-softphone' });

  return (
    <>
      <Text>
        <Trans t={t}>
          Set the device name for <b>{values?.firstName}'s</b> softphone. You can change the device name at any time in
          the Admin Portal.
        </Trans>
      </Text>

      <Heading level={3}>{t('Device Extension Number')}</Heading>
      <Text>{getFieldProps('extension').value}</Text>

      <Heading level={3}>{t('Device Name')}</Heading>

      <FormRow css={inputFieldStyles}>
        <TextField
          helperText={t('This name is used to identify the device with configurations.')}
          {...getFieldProps('deviceName')}
          label={t('Device Name')}
        />
      </FormRow>

      <FormRow css={inputFieldStyles}>
        <TextField
          helperText={t('This name will appear on the devices you call.')}
          {...getFieldProps('internalIDName')}
          label={t('Internal ID Name')}
        />
      </FormRow>
    </>
  );
};
